import remoteTimeNow from 'libs/remote-time-now';
import moment from 'moment';

const isChatroomDisabled = (config: any = {}) => {
  if (config.isChatroomDisabled) return true;
  const periods = config.enableChatroomPeriods || [];
  if (periods.length === 0) return false;
  const now = remoteTimeNow();
  return !periods.some(({ from, to }) => now.isBetween(moment(from), moment(to)));
};

export default isChatroomDisabled;
